<div class="hero-body has-text-centered">
	<h2 class="title red is-3">Nosotros</h2>
	<p>
		Centro de Calibración y Capacitación Industrial (CCCISA); es una empresa que inicia
		labores en el año 2004, y estamos dedicados a prestar servicios de calibración, 
		calificación y ensayo acreditados ante la Entidad Mexicana de Acreditación, A.C. en 
		las magnitudes de:
	</p>
	<p>
		<strong>
			MASA, HUMEDAD, TEMPERATURA, PRESIÓN, DIMENSIONAL, MEDICIONES ESPECIALES, METAL 
			MECÁNICA (Pruebas de Válvulas) y VOLUMEN.
		</strong>
	</p>
	<p style="margin-bottom: 1em;">
		Cumplimos los requisitos de la norma NMX-EC-17025-IMNC-2006; "Requisitos generales 
		para la competencia de los laboratorios de ensayo y calibración".
	</p>
	<p>
		Estamos expandiendo nuestros servicios en el ramo de <strong>SEGURIDAD E HIGIENE</strong>. Ofrecemos los servicios en las siguientes normas:
	</p>
	<p style="margin-bottom: 1em;">
		<strong>
			NOM-011-STPS-2001, NOM-025-STPS-2008, NOM-022-STPS-2015, NOM-024-STPS-2001.
		</strong>
	</p>
	<p>
		También contamos con servicio de mantenimiento, reparación y fabricación de equipo para laboratorios e industrial, 22 años de experiencia al servicio de la industria nos respaldan.
	</p>

	<h4 class="title is-5	blue" style="margin-top: 3em">
		NUESTRA INFRASTRUCTURA DE SERVICIOS ESTÁ RESPALDADA POR LA MARCA CCCISA.
	</h4>
</div>
